import { createSlice } from '@reduxjs/toolkit';
import indexOf from 'lodash/indexOf';

import { TYPE } from '../../Screens/Search/types';

const initialState = {
  recentlySearched: [],
  recentlyReservationSearched: [],
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    pushRecentlySearch: (state, action) => {
      const { type, value } = action.payload;
      const searchState = {
        [TYPE.HOME]: state.recentlySearched,
        [TYPE.RESERVATION]: state.recentlyReservationSearched,
      };
      const recentlySearched = searchState[type];
      const searchValue = value.toLowerCase();
      const resultIndex = indexOf(recentlySearched, searchValue);
      const isExist = resultIndex !== -1;
      if (isExist) {
        // remove it from the array and below code will push the searched to the first item
        recentlySearched.splice(resultIndex, 1);
      }
      recentlySearched.unshift(searchValue); // push the element to first
      if (recentlySearched.length >= 4) {
        // after adding the searched to redux and it has more than 4
        recentlySearched.length = 4; // limit the search length to 4 only
      }
    },
    removeRecentlySearch: (state, action) => {
      const { type, value } = action.payload;
      const searchState = {
        [TYPE.HOME]: state.recentlySearched,
        [TYPE.RESERVATION]: state.recentlyReservationSearched,
      };
      const recentlySearched = searchState[type];
      if (value) {
        // if has payload, remove individual
        const searchIndex = indexOf(recentlySearched, value);
        recentlySearched.splice(searchIndex, 1);
      } else {
        // if no payload, remove all
        recentlySearched.length = 0;
      }
    },
  },
});

export const { pushRecentlySearch, removeRecentlySearch } = searchSlice.actions;
export default searchSlice.reducer;
